import React, { Fragment, useState, useEffect, useRef} from "react";
import { Row, Col, Container, Card, Collapse } from "reactstrap";
import "../../style/styleeconfirm.css";


export default function PopUp(props) {
  // const {toggle}=props.toggle;
  const [open, setOpen] = useState('false');

  useEffect(() => {
    props.toggle ==true ? setOpen('true') : setOpen('false')
  }, [props.toggle]);

  return (
    <div className="popup-overlayn">
      <div className="popup-contentn">
<br/>
<div>
  <i class="fa fa-trash" aria-hidden="true" style={{fontSize:"2.5em"}}></i>
  </div>
<br/>
<h5>Are you sure you want to delete?</h5>

<br/>

<div>
<button className="btn-admin-settings btn btn-" onClick={props.hadleDelWithPopYes}>Yes</button>&nbsp;&nbsp;
<button className="btn-cancel btn btn-" onClick={props.hadleDelWithPopNo}>No</button>
</div>
<br/>
{/* </div> */}
</div>
      </div>

  );
}
